import Vue from "vue";

Vue.component("modification-matcher", {
    props: ["old","latest","oldNative","latestNative", "updated", "deleted", "added", "showIcon", "useDiffMatch", "applyInlineStyle"],
    computed: {
        modifications: function () {
            const self = this;
            console.log(self);
            let result = '';
            const showLatest = (self.latest != null && self.latest != '');

            if (self.deleted && showLatest) {
                result += `<del class="modification-deleted">${self.latest}</del>`;
            }
            else if (self.updated) {
                if (self.old != null && self.old != '' && showLatest) {

                    if (self.useDiffMatch) {
                        let dmp = new diff_match_patch();
                        var diff = dmp.diff_main((self.added ? '' : self.old), self.latest);

                        result += dmp.diff_prettyHtml(diff);

                        if (self.oldNative != null && self.oldNative != '') {
                            let ndmp = new diff_match_patch();
                            var ndiff = ndmp.diff_main(self.oldNative, self.latestNative);

                            result += ' (' + ndmp.diff_prettyHtml(ndiff) + ')';
                        }
                        else if (self.latestNative != null && self.latestNative != '') {
                            result += ' (' + self.latestNative + ')';
                        }
                    }
                    else {
                        result += ((self.old != self.latest) ? `<del>${self.old}</del>&nbsp;<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">${self.latest}</span>` : self.latest);

                        if (self.oldNative != null && self.oldNative != '') {
                            if (self.oldNative != self.latestNative) {
                                result += `(<del>${self.oldNative}</del>&nbsp;<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">${self.latestNative}</span>)`
                            }
                            else {
                                result += ' (' + self.latestNative + ')';
                            }
                        }
                        else if (self.latestNative != null && self.latestNative != '') {
                            result += ' (' + self.latestNative + ')';
                        }
                    }
                }
                else {
                    if (showLatest) {
                        result += ('<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">' + self.latest + '</span>');

                        if (self.latestNative != null && self.latestNative != '') {
                            result += ('(<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">' + self.latestNative + '</span>)');
                        }
                    }
                }
            }            
            else {
                if (showLatest) {
                    if (self.applyInlineStyle) {
                        result += (self.added ? ('<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">' + self.latest + '</span>') : self.latest);

                        if (self.latestNative != null && self.latestNative != '') {
                            result += (self.added ? ' (<span style="font-weight: bold; background: #e6ffe6; text-decoration: underline;">' + self.latestNative + '</span>)' : (' (' + self.latestNative + ')'));
                        }

                    }
                    else {
                        result += self.latest;

                        if (self.latestNative != null && self.latestNative != '') {
                            result += ' (' + self.latestNative + ')';
                        }
                    }
                }
            }

            if (self.showIcon) {
                if (self.added) {                    
                    result += '&nbsp;<i class="fas fa-plus"></i>';
                }

                if (self.deleted) {
                    result += '&nbsp;<i class="fas fa-trash"></i>';
                }

                if (self.updated) {
                    result += '&nbsp;<i class="fas fa-pen"></i>';
                }
            }

            return result;
        }
    },
    template: `
        <div v-html="modifications"></div>
	`
});